import { render } from "./LocationIcon.vue?vue&type=template&id=1994f661"
import script from "./LocationIcon.vue?vue&type=script&lang=js"
export * from "./LocationIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__